import { useFlags } from 'launchdarkly-react-client-sdk'

export const useFeatureFlags = useFlags
